import { ChevronDownIcon } from "@heroicons/react/24/outline"
import Icon from "aldoo-ra/Icon"
import Localization from "aldoo-ra/Localization"
import Menu from "aldoo-ra/Menu"
import React, { useState, useEffect, useRef } from "react"
import Button from "aldoo-ra/Button"

export default function SiteLanguageSelector() {
  const { currentLanguageName, setLanguage, languages } = Localization()
  const [isHelpCenterPage, setIsHelpCenterPage] = useState(false)
  const isInitialMount = useRef(true)

  // Function to check if a path is a help center page
  const checkIsHelpCenterPath = (path) => {
    // Normalize path to ensure it starts with a slash
    const normalizedPath = path.startsWith("/") ? path : `/${path}`
    return normalizedPath.startsWith("/help-center")
  }

  useEffect(() => {
    // Only run in browser environment
    if (typeof window === "undefined") return

    // Function to check URL and update visibility
    const updateVisibility = () => {
      const currentPath = window.location.pathname
      const isHelpCenter = checkIsHelpCenterPath(currentPath)
      setIsHelpCenterPage(isHelpCenter)
    }

    // Set initial state on mount based on current URL
    if (isInitialMount.current) {
      updateVisibility()
      isInitialMount.current = false
    }

    // Set up event listeners for different types of navigation
    window.addEventListener("popstate", updateVisibility)
    window.addEventListener("hashchange", updateVisibility)

    // For history API calls (pushState, replaceState)
    const originalPushState = window.history.pushState
    const originalReplaceState = window.history.replaceState

    window.history.pushState = function () {
      originalPushState.apply(this, arguments)
      updateVisibility()
    }

    window.history.replaceState = function () {
      originalReplaceState.apply(this, arguments)
      updateVisibility()
    }

    return () => {
      // Clean up event listeners
      window.removeEventListener("popstate", updateVisibility)
      window.removeEventListener("hashchange", updateVisibility)

      // Restore original history methods
      window.history.pushState = originalPushState
      window.history.replaceState = originalReplaceState
    }
  }, [])

  const menu = {
    label: currentLanguageName(),
    items: languages.map((language) => {
      return {
        options: { action: () => setLanguage(language.code) },
        label: language.displayName,
      }
    }),
  }

  return (
    <div
      className={`flex items-center justify-end md:mr-4 lg:mr-0 ${
        isHelpCenterPage ? "hidden" : ""
      }`}
    >
      <Menu
        menuData={menu}
        hideOnItemClick
        renderAs="vlist.menu"
        variant="mobilingo_vlist.menu_bordered"
        maxItemsPerColumn={4}
        menuAlign="right"
        menuItemRender={(item) => {
          return (
            <div className="w-[100px] flex flex-row gap-1 items-center">
              <div>{item.label}</div>
            </div>
          )
        }}
        rootItemRender={(item) => {
          return (
            <>
              <Button
                variant="nav_menuitem"
                className="w-[50px] md:w-auto flex flex-row justify-end items-center flex-shrink-0 gap-[3px] px-0 group"
              >
                <Icon
                  id="globe_icon"
                  recolor={true}
                  className="w-[25px] h-[25px] flex-shrink-0 text-text group-hover:text-primary"
                />
                {/* <div className="hidden md:block">
                {currentLanguageName()}
                </div> */}
                <div className="flex items-center justify-center flex-shrink-0">
                  <ChevronDownIcon className="w-5 h-5 group-hover:text-primary group-hover:rotate-180 transition-transform duration-300" />
                </div>
              </Button>
            </>
          )
        }}
      />
    </div>
  )
}
